import bodyFontReg from './karelia-medium.woff2';

import { css } from 'linaria';

export default function loadCss() {
  return css`
    :global(html) {
      @font-face {
        font-family: 'karelia';
        src: url(${bodyFontReg}) format('woff2');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
      }
    }
  `;
}
